export default __webpack_public_path__ + "0ede3adf0ea6580e9a947778184244aa.png";